<template>
  <div class="flex-center">
    <i class="error-circle-icon main" :id="'error-' + uuid"></i>
    <popover
      :target="'error-' + uuid"
      triggers="hover"
      boundary="viewport"
      :show-delay="200"
      @hide="onHide"
    >
      <div class="d-flex align-items-center mb-3">
        <i class="error-circle-icon"></i>
        <b class="text-normal-1 ml-2">Review goal contributions</b>
      </div>
      <div class="text-medium-1 mb-3 left-spacing">
        Some changes in Child Goal or Key results may have impacted this goal’s reporting.
      </div>
      <div class="text-medium-1 d-flex align-items-center">
        <i class="goal-progress-icon"></i>
        <link-button class="ml-2 px-0" @click="isSetupGoalProgressModalShown = true"
          >Review goal contributions</link-button
        >
      </div>
    </popover>
    <setup-goal-progress-modal
      :goal-id="goal.id"
      :source="SOURCE.REVIEW_CONTRIBUTIONS_POPOVER"
      v-model="isSetupGoalProgressModalShown"
      v-if="isSetupGoalProgressModalShown"
    />
  </div>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton'
import SetupGoalProgressModal from '@/components/goal/SetupGoalProgressModal'
import { SOURCE } from '@/constants/analytics'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import Popover from '@/components/Popover'

/**
 * This shows a warning when contributions from all the contributors of a goal sum up to less than 100.
 */
export default {
  name: 'ReviewGoalContributionsPopover',
  mixins: [ComponentIdMixin],
  props: ['goal'],
  components: {
    Popover,
    LinkButton,
    SetupGoalProgressModal
  },
  data() {
    return {
      isSetupGoalProgressModalShown: false,
      SOURCE
    }
  },
  computed: {},
  methods: {
    onHide(e) {
      if (this.isSetupGoalProgressModalShown) {
        e.preventDefault()
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.left-spacing {
  padding-left: 25px;
}
.goal-progress-icon {
  border: 1px solid $borderPrimary;
  border-radius: 5px;
}
.main.error-circle-icon {
  @include dimension(14px, 14px);
}
</style>
